module.exports = __webpack_public_path__ + "img/logo-nasa.91c612fc.svg";